import {
    LoginTypes
} from 'actions/types';
import axios from 'axios';
import { normalizeError } from 'utils/logError';

export function login(username, password) {
    return (dispatch, getState) => {
        let headers, url, method, params;
        try {
            const currentLoginIndex = getState().config.get('currentLoginIndex');
            const route = getState().urls.getIn(['loginUrls', currentLoginIndex]);
            headers = getState().config.get('headers').toJSON();
            url = route.get('href');
            method = route.get('method');
            const codeChallenge = getState().security.get('codeChallenge');
            params = {
                username,
                password,
                codeChallenge
            }

        } catch(error) {
            dispatch(loginError(error))
            throw error
        }

        dispatch({
            type: LoginTypes.LOGIN,
            payload: params
        })

        return axios({ method, url, headers, data: params })
        .then(({ data }) => {
            dispatch(loginSuccess(data))
            return data
        })
        .catch(error => {
            const normalized = normalizeError(error)
            dispatch(loginError(normalized))
            throw normalized
        })
    }
}

export function loginSuccess(response) {
    return (dispatch, getState) => {
        dispatch({
            type: LoginTypes.LOGIN_SUCCESS,
            payload: response
        })
    }
}

export function loginError(error) {
    return {
        type: LoginTypes.LOGIN_ERROR,
        payload: error
    }
}

export function logout() {
    return (dispatch, getState) => {
        dispatch({
            type: LoginTypes.LOGOUT
        })
    }
}